import type { ComunicadoComRelacoes } from "@/modules/comunicados/services/comunicadosService";

/** "Toda a igreja" ou os nomes dos ministérios — só faz sentido quando o banco liberou os detalhes. */
export function rotuloDestino(c: ComunicadoComRelacoes): string {
  return c.destinos.length ? c.destinos.map((d) => d.ministerioNome).join(", ") : "Toda a igreja";
}

/**
 * Nomes dos ministérios de destino quando a pessoa (que enxerga os detalhes:
 * gestão do elo ou administrador) NÃO participa de nenhum deles — ela vê o
 * comunicado por ser da gestão, e a tela avisa isso ("Só: Louvor"). `null`
 * quando é da igreja toda, quando a pessoa participa de algum destino, quando
 * o banco não liberou os detalhes ou enquanto os ministérios dela carregam.
 */
export function ministeriosSoPara(
  c: ComunicadoComRelacoes,
  meusMinisterios: ReadonlySet<string> | undefined,
): string | null {
  if (!c.detalhesVisiveis || !c.destinos.length || !meusMinisterios) return null;
  if (c.destinos.some((d) => meusMinisterios.has(d.ministerioId))) return null;
  return c.destinos.map((d) => d.ministerioNome).join(", ");
}
